"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DurationPicker = void 0;
const mithril_1 = __importDefault(require("mithril"));
const helpers_1 = require("../utils/helpers");
exports.DurationPicker = {
    view(vnode) {
        const opts = vnode.attrs;
        const minDuration = opts.minDuration || 0;
        const maxDuration = opts.maxDuration || Number.POSITIVE_INFINITY;
        const step = opts.step || 1;
        const value = opts.value || 0;
        const onchange = opts.onchange || (() => { });
        const onclick = (v, s) => {
            return () => {
                let newV = v + s;
                newV = Math.max(newV, minDuration);
                newV = Math.min(newV, maxDuration);
                if (value != newV) {
                    onchange(newV);
                }
            };
        };
        const validateInput = (evt) => {
            const text = evt.target.value;
            const minutePattern = /([0-9]+)/;
            const hourPattern = /([0-9]{1,2}):([0-9]{2})/;
            let totalTime = minDuration;
            if (minutePattern.test(text)) {
                totalTime = parseInt(text);
                totalTime = Math.ceil(totalTime / step);
                totalTime = totalTime * step;
            }
            else if (hourPattern.test(text)) {
                // It's valid, we will match the blocks
                const matched = text.match(hourPattern);
                const g1 = matched[1], g2 = matched[2];
                //We find the proper time according to step and minmax
                let totalTime = parseInt(g1) * 60 + parseInt(g2);
                totalTime = Math.ceil(totalTime / step);
                totalTime = totalTime * step;
            }
            onclick(totalTime, 0)();
            mithril_1.default.redraw();
        };
        let minusDisabled, plusDisabled;
        minusDisabled = value == minDuration ? "disabled" : "enabled";
        plusDisabled = value == maxDuration ? "disabled" : "enabled";
        return (0, mithril_1.default)("div", { class: "duration-picker" }, (0, mithril_1.default)("div", { class: `duration-minus ${plusDisabled}`, onclick: onclick(value, step) }, (0, helpers_1.iconSpan)("fa-plus")), (0, mithril_1.default)("div", { class: "current-duration" }, (0, mithril_1.default)("input", { type: "text", value: (0, helpers_1.minutesToString)(value),
            onblur: validateInput,
            onfocus: (evt) => { evt.target.select(); },
            onkeydown: (evt) => {
                switch (evt.code) {
                    case "ArrowDown":
                        onclick(value, -step)();
                        break;
                    case "ArrowUp":
                        onclick(value, step)();
                        break;
                }
            }
        })), (0, mithril_1.default)("div", { class: `duration-plus ${minusDisabled}`, onclick: onclick(value, -step) }, (0, helpers_1.iconSpan)("fa-minus")));
    }
};
